export default function fadeIn(el, duration = 200, updateTabIndex = false, addAriaHidden = false) {
	if (!el) {
		return;
	}

	el.style.opacity = 0;
	el.style.display = 'block';
	el.style.transition = `opacity ${duration}ms`;

	if (updateTabIndex) {
		el.setAttribute('tabindex', '0');
	}
	if (addAriaHidden) {
		el.setAttribute('aria-hidden', false);
	}

	window.setTimeout(function() {
		el.style.opacity = 1;
	}, 10);
}
